import { LoadingSpinner } from '@simplywallst/ui-core';
import { PeriodSelect } from '../PeriodSelect';
import type { Period } from '../../types';

type Props = {
  period: Period;
  benchmarkMetricLabel: string;
};

export const LoadingState = ({ period, benchmarkMetricLabel }: Props) => {
  return (
    <div className="relative grid gap-4 p-x2 lg:px-x3 lg:py-x2">
      <div className="grid h-[55px] grid-cols-2 lg:h-[59px]">
        <div className="grid grid-cols-[max-content_max-content] gap-9">
          <div className="grid gap-2">
            <div className="mt-x0_75 grid grid-cols-[min-content_auto] place-items-center gap-2">
              <div className="h-x0_25 w-2 bg-p-white-100/70" />
              <p className="mb-0 text-xs text-soft">Holdings</p>
            </div>
            <div className="bones h-6 w-full" />
          </div>
          <div className="grid gap-2">
            <div className="mt-x0_75 grid grid-cols-[min-content_auto] place-items-center gap-1">
              <div className="h-x0_25 w-2 bg-p-white-100/70" />
              <p className="mb-0 pl-[7px] text-xs text-soft">
                {benchmarkMetricLabel}
              </p>
            </div>
            <div className="bones h-6 w-full" />
          </div>
        </div>
        <PeriodSelect period={period} />
      </div>
      <div className="grid grid-rows-[200px]">
        <div
          data-cy-id="loading-portfolio-performance-timeseries"
          className="grid place-content-center bg-p-white-100/10"
        >
          <LoadingSpinner light />
        </div>
      </div>
    </div>
  );
};
